import React, { useEffect, useRef } from "react";
import EventoVisualizarController from "../../DefaultPage/Evento/controller/evento-visualizar.controller";
import AuthService from "../../../../vendors/services/authService";

export default function EventoInternoAuth() {
  const authService = new AuthService();
  const controller = new EventoVisualizarController(true);

  useEffect(() => {
    controller.start();
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    const login = urlParams.get("login");
    const idEventoInterno = urlParams.get("id");
    console.log(token, "token");
    if (!token) {
      sessionStorage.removeItem("authToken");
      window.location.href = "/login/unico";
      return;
    }

    if (token) {
      sessionStorage.setItem("authToken", token);
      sessionStorage.setItem("internalAccess", "true");
    }

    if (login) {
      sessionStorage.setItem("login", login);
    }

    if (idEventoInterno) {
      sessionStorage.setItem("idEventoInterno", idEventoInterno);
    }

    controller.history.push("/evento-interno", { id: idEventoInterno });
    controller.stop();
  }, []);

  return <></>;
}
